import React, { useState } from "react";
import { Box, Dialog, IconButton } from "@mui/material";
import styles from "./index.module.scss";
import { useModel } from "hooks/useModel";
import ChatList from "./components/ChatList/ChatList";
import ChatArea from "./components/ChatArea/ChatArea";
import PromptsCard from "./components/Prompts/PromptsCard";
import NavButtonGroup from "./components/NavButtonGroup";
import PromptForm from "./components/Prompts/PromptForm";
const AppContent = (props: { onClose: () => void }) => {
  const { promptsOpen, promptConfig, fullScreen, drawerWidth, chatlist, selectedKey } =
    useModel("aichat");
  const [show, setShow] = useState(true);
  const [expandPromptForm, setExpandPromptForm] = useState(false);

  return (
    <Box className={styles.AIbox}>
      {show && fullScreen && (
        <Box className={styles.menus}>
          <ChatList />
        </Box>
      )}
      <Box className={styles.right}>
        <Box className={styles.top}>
          <Box className={styles.title}>
            {fullScreen && !show && (
              <IconButton onClick={() => setShow(true)}>
                <img
                  src="/aichat/showMenu.svg"
                  alt=""
                />
              </IconButton>
            )}
            {fullScreen && show && (
              <IconButton onClick={() => setShow(false)}>
                <img
                  src="/aichat/hideMenu.svg"
                  alt=""
                />
              </IconButton>
            )}
            <span>SP AI Assistant</span>
          </Box>
          <Box className={styles.chatTitle}>
            {chatlist.find((item) => item.id === selectedKey)?.topicName || ""}
          </Box>
          <NavButtonGroup onClose={props.onClose} />
        </Box>
        <Box className={styles.mainContent}>
          <Box
            className={styles.chat}
            style={{
              width: fullScreen
                ? `calc(100vw - ${promptsOpen ? "424px" : "0px"} - ${show ? "276px" : "0px"} - 60px)`
                : `calc(${drawerWidth} - 8px)`,
            }}
          >
            <ChatArea />
          </Box>
          {promptsOpen && promptConfig.state === "close" && (
            <Box className={styles.quickPrompts}>
              <PromptsCard />
            </Box>
          )}
          {promptConfig.state !== "close" && !expandPromptForm && (
            <Box
              className={styles.quickPrompts}
              style={{ overflowY: "scroll" }}
            >
              <PromptForm setExpand={setExpandPromptForm} />
            </Box>
          )}
          <Dialog
            // todo tr 这里还要再加一个状态来区分是dialog还是侧边栏打开
            onClose={() => {}}
            maxWidth={false}
            open={promptConfig.state !== "close" && expandPromptForm}
            PaperProps={{
              style: {
                margin: 0,
                padding: "16px 24px",
                width: "80vw",
                boxShadow: "none",
                overflowY: "auto",
              },
            }}
          >
            <PromptForm
              type="dialog"
              setExpand={setExpandPromptForm}
            />
          </Dialog>
        </Box>
      </Box>
    </Box>
  );
};

export default AppContent;
